import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { getCheckoutState } from 'merchant-api/checkout';
import { checkout } from '..';

interface IdentityAnswersProps {
  isErrorIdentityAnswers: any;
  identityAnswersData: any;
  sendIdentityAnswers: any;
  isLoadingIdentityAnswers: boolean;
  mutation: UseMutationResult<any, Error, any>;
}

export function postIdentityAnswers(): IdentityAnswersProps {
  const queryClient = useQueryClient();
  const { checkoutData, isLoadingCheckoutState, isErrorCheckoutState } = getCheckoutState();

  const mutation = useMutation({
    mutationFn: async (arg: any) => {
      const data = await checkout.post(`/v1/identity-verification/${checkoutData?.checkoutUuid}/iq?`, arg).then((res) => res.data);
      await queryClient.invalidateQueries({queryKey: ['checkout']});
      return data;
    },
    mutationKey: ['postIdentityAnswers'],
  });

  return {
    isErrorIdentityAnswers: mutation.error || isErrorCheckoutState,
    isLoadingIdentityAnswers: mutation.isPending || isLoadingCheckoutState,
    sendIdentityAnswers: mutation.mutateAsync,
    identityAnswersData: mutation.data,
    mutation,
  };
}
